module.exports = __webpack_public_path__ + "img/4.f1b5df4f.png";